import React from 'react';
import { Tooltip, Icon } from 'evergreen-ui';

export const RushOrderBadge = () => (
  <Tooltip content="Rush Order">
    <Icon icon="stopwatch" color="muted" size={14} marginLeft={10} />
  </Tooltip>
);
